import { Navigate, Route, Routes } from 'react-router-dom';
import { isOffice, useAuth } from './auth';
import { Layout } from './components/Layout';
import { Loading } from './components/ui';
import { useT } from './i18n';
import { ClientsPage } from './pages/Clients';
import { CrewPage } from './pages/Crew';
import { EquipmentPage } from './pages/Equipment';
import { EventDetailPage } from './pages/EventDetail';
import { EventsPage } from './pages/Events';
import { HomePage } from './pages/Home';
import { ItemDetailPage } from './pages/ItemDetail';
import { KitDetailPage, KitsPage } from './pages/Kits';
import { LabelsPage } from './pages/Labels';
import { LoginPage } from './pages/Login';
import { SettingsPage } from './pages/Settings';
import { TimesheetsPage } from './pages/Timesheets';
import { InterpretersPage } from './pages/Interpreters';
import { VenuesPage } from './pages/Venues';

export function App() {
  const { user, loading, logout, connectionError, refresh } = useAuth();
  const t = useT();
  if (loading) return <Loading />;
  if (!user && connectionError) {
    return (
      <div className="login-page">
        <div className="card login-card stack">
          <img className="logo" src="/logo.png" alt="Translation Centre" />
          <div className="alert alert-error">{t('err.network')}</div>
          <button className="btn btn-primary" onClick={() => void refresh()}>{t('common.retry')}</button>
        </div>
      </div>
    );
  }
  if (!user) return <LoginPage />;
  // The dashboard is for the office. Technicians use the phone app.
  if (!isOffice(user)) {
    return (
      <div className="login-page">
        <div className="card login-card">
          <img className="logo" src="/logo.png" alt="Translation Centre" />
          <p className="title">{t('login.useApp')}</p>
          <button className="btn" style={{ width: '100%' }} onClick={logout}>
            {t('nav.logout')}
          </button>
        </div>
      </div>
    );
  }
  return (
    <Routes>
      <Route path="/labels" element={<LabelsPage />} />
      <Route element={<Layout />}>
        <Route index element={<HomePage />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/events/:id" element={<EventDetailPage />} />
        <Route path="/equipment" element={<EquipmentPage />} />
        <Route path="/equipment/:id" element={<ItemDetailPage />} />
        <Route path="/kits" element={<KitsPage />} />
        <Route path="/kits/:id" element={<KitDetailPage />} />
        <Route path="/timesheets" element={<TimesheetsPage />} />
        <Route path="/crew" element={<CrewPage />} />
        <Route path="/interpreters" element={<InterpretersPage />} />
        <Route path="/venues" element={<VenuesPage />} />
        <Route path="/clients" element={<ClientsPage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
